import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  contentContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
    border: '1px solid black',
    padding: 10,
    borderRadius: '5px'
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  text: {
    fontSize: 9
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 10
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableHeaderCell: {
    fontSize: 9,
    fontWeight: 'bold',
    backgroundColor: '#f0f0f0',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 4,
    textAlign: 'center'
  },
  tableCell: {
    fontSize: 9,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 4,
    textAlign: 'center'
  },
  logo: {
    width: '100%',
    height: '80px',
    marginBottom: 10
  },
  row1: {
    flexDirection: 'row',
    marginBottom: 0
  }
});

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const AllReceiptVoucherPdf = ({ datas, data }) => {
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const COLORS = ['#ffffff', '#e0e0e0'];

  const numberToWords = (num) => {
    const ones = [
      '',
      'one',
      'two',
      'three',
      'four',
      'five',
      'six',
      'seven',
      'eight',
      'nine',
      'ten',
      'eleven',
      'twelve',
      'thirteen',
      'fourteen',
      'fifteen',
      'sixteen',
      'seventeen',
      'eighteen',
      'nineteen'
    ];
  
    const tens = [
      '',
      '',
      'twenty',
      'thirty',
      'forty',
      'fifty',
      'sixty',
      'seventy',
      'eighty',
      'ninety'
    ];
  
    const thousands = ['', 'thousand', 'million', 'billion'];
  
    if (num === 0) {
      return 'zero';
    }
  
    let word = '';
    let i = 0;
  
    while (num > 0) {
      if (num % 1000 !== 0) {
        word = `${helper(num % 1000)} ${thousands[i]} ${word}`;
      }
      num = Math.floor(num / 1000);
      i++;
    }
  
    return word.trim();
  
    // Helper function to convert numbers less than 1000
    function helper(num) {
      if (num === 0) return '';
      if (num < 20) return ones[num];
      if (num < 100) return `${tens[Math.floor(num / 10)]} ${ones[num % 10]}`.trim();
      return `${ones[Math.floor(num / 100)]} hundred ${helper(num % 100)}`.trim();
    }
  };
    // Calculate the total amount
    const totalAmount = data.reduce((acc, item) => acc + Number(item.received_amount || 0), 0);
    // Convert the total amount to words
    const amountInWords = `${numberToWords(totalAmount)} rupees only`;
  return (
    <PDFViewer width="100%" height="100%" showToolbar>
      <Document title="Receipt Voucher">
        <Page size="A4">
          <PDFImage src="/logo_Hospital_m.jpeg" style={styles.logo} />
          <View style={styles.row}>
            <Text content="Payment Details" style={{ fontSize: 12, margin: '0 auto', fontFamily: 'Roboto' }} />
          </View>

          {/* Patient Header Info (first item) */}
          <View style={styles.contentContainer}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="UHID/IPD No           :  " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
                <Text content={` ${data[0].uhid}/${data[0].ipd_no}`} />
              </View>
              <View style={styles.row}>
                <Text content="Patient Name          :  " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
                <Text content={` ${data[0].patientName}`} />
              </View>
              <View style={styles.row}>
                <Text content="Address                   :  " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
                <Text content={` ${data[0].address}`} />
              </View>
              <View style={styles.row}>
                <Text content="Age/Sex                   :  " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
                <Text content={` ${data[0].age} / ${data[0].gender}`} />
              </View>
            </View>

            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Mobile                   :  " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
                <Text content={` ${data[0].mobile}`} />
              </View>
              <View style={styles.row}>
                <Text content="Department          : " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
                <Text content={` ${data[0].department}`} />
              </View>
              <View style={styles.row}>
                <Text content="Sponsor                :  " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
                <Text content={` ${data[0].sponsor}`} />
              </View>
            </View>
          </View>

          <View style={{ ...styles.row1, padding: '5px', backgroundColor: 'navy', color: 'white' }}>
            <Text style={{ ...styles.columnHeader, width: '20%' }} content="Sr No." />
            <Text style={{ ...styles.columnHeader, width: '20%' }} content="Receipt No." />
            <Text style={{ ...styles.columnHeader, width: '20%' }} content="Receipt Date" />
            <Text style={{ ...styles.columnHeader, width: '20%' }} content="Payment Mode" />
            <Text style={{ ...styles.columnHeader, width: '20%' }} content="Amount Paid" />
          </View>
          {data &&
            data?.map((item, index) => (
              <View
                key={index}
                style={{ ...styles.row1, backgroundColor: COLORS[index % COLORS.length], padding: '5px' }}
              >
                <Text style={{ ...styles.columnContent, width: '33%' }} content={index + 1} />
                <Text
                  style={{
                    ...styles.columnContent,
                    textAlign: 'start',
                    width: '33%',
                    flexWrap: 'wrap',
                    overflow: 'hidden'
                  }}
                  content={item.receipt_no}
                />
                <Text
                  style={{
                    ...styles.columnContent,
                    textAlign: 'start',
                    width: '33%',
                    flexWrap: 'wrap',
                    overflow: 'hidden'
                  }}
                  content={formatDate(item.date)}
                />
                <Text
                  style={{
                    ...styles.columnContent,
                    textAlign: 'start',
                    width: '33%',
                    flexWrap: 'wrap',
                    overflow: 'hidden'
                  }}
                  content={item.payment_mode}
                />
                <Text style={{ ...styles.columnContent, width: '33%' }} content={`${item.received_amount}`} />
              </View>
            ))}
          <View style={{...styles.row,justifyContent:"flex-end",width:"84%",marginTop:"2%"}}>
            <Text style={{ ...styles.textBold, fontFamily: 'Roboto' }} content="Total Amount Paid :  " />
            <Text content={Number(data.reduce((acc, item) => acc + Number(item.received_amount || 0), 0))} />
          </View>

          <View style={{...styles.row,justifyContent:"flex-start",width:"84%",marginTop:"2%"}}>
            <Text style={{ ...styles.textBold, fontFamily: 'Roboto', }} content="Amount in Words :  " />
            <Text content={amountInWords}  style={{color:"green",fontFamily:"Roboto",fontSize:"10px"}} />
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};
